import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {CountriesModel} from './CountriesModel';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
     // 'Content-Type': 'application/json; charset=utf-8',
     // 'Authorization': "Bearer " + token,
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 getAll(): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}Countries/GetAll`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}


getById(Id:number): Observable<any> {

  return this.http
    .get<any>(`${this.baseUrl}Countries/GetById/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
insert(payload: CountriesModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}Countries/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

update(payload: CountriesModel): Observable<any> {
  return this.http
    .post<any>(`${this.baseUrl}Countries/Update`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

delete(Id:number): Observable<any> {
  return this.http
    .get<any>(`${this.baseUrl}Countries/Delete/${Id}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

  deleteList(payload: CountriesModel []): Observable<any> {
    console.log(JSON.stringify(payload))
    return this.http
      .post<any>(`${this.baseUrl}Countries/DeleteList`,JSON.stringify(payload),this.httpOptions)
      .pipe(catchError((error: any) => throwError(error => error)));
  }
}
